/*
 * @Description: 发票
 * @Author: ywj
 * @Date: 2025-03-25 10:48:20
 * @LastEditTime: 2025-04-17 09:35:12
 * @LastEditors: ywj@originqc.com
 */
import React, { useState, useEffect } from "react";
import { Modal, Button, message } from 'antd';
import receipt from '../../imgs/receipt.png'
import { getBill, downloadBill } from '@/api/my-invoice';
import { windowOpenUrl } from '@/utils/index'
import './index.scss';
// import { Document, Page } from 'react-pdf';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import * as pdfjs from 'pdfjs-dist';
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs';
// pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;



interface IViewProps {
  showReceiptModal: boolean;
  setShowReceiptModal: (showReceiptModal: boolean) => void;
  orderId?: number|string;
}
const ReceiptModal: React.FC<IViewProps> = (props) => {
  const { showReceiptModal, setShowReceiptModal,orderId='' } = props;
  const [receiptUrl, setReceiptUrl] = useState<string>('');
  const [pageNumber, setPageNumber] = useState(1);
  useEffect(() => {
    if (showReceiptModal) {
      handleGetBill();
    }
  }, [showReceiptModal]);

  const handleGetBill = () => {
    getBill(orderId).then((res: any) => {
      if (res.success) {
        setReceiptUrl(res.obj?.showUrl);
      } else {
        message.error(res.message);
      }
    })
  }
  const handleDownload = () => {
    window.location.href=`${window.location.origin}/attachCenter/invoice/downloadBill.json?orderId=${orderId}`
  }
  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setPageNumber(numPages);
  }
  return <Modal
    width={752}
    height={600}
    centered
    open={showReceiptModal}
    title='查看发票'
    className='my-invoice-receipt-modal'
    onCancel={() => setShowReceiptModal(false)}
  >
      <div className="pdf-container">
      <embed src={`${receiptUrl}#toolbar=0`} width="100%" height="100%"  type='application/pdf' style={{ border: 'none', outline:'none'}}></embed>
      </div>
   
    {/* </div> */}

    <div className="dialog-bottom">
      <Button className='submit-info' onClick={handleDownload}>下载</Button>

    </div>

  </Modal>
}

export default ReceiptModal;
